import * as React from "react";
function _convertValidationErrors(errors, name) {
    if (errors instanceof Array) {
        return errors;
    }
    else if (errors instanceof Object) {
        return errors[name];
    }
    else if (typeof errors === "string") {
        return [errors];
    }
    return null;
}
export function ValidationErrors(props) {
    var errors = _convertValidationErrors(props.errors, props.name);
    if (errors) {
        return React.createElement("div", { className: props.className || "text-danger" }, errors.map((e, idx) => React.createElement("div", { key: idx }, e)));
    }
    return null;
}
export function ValidationSummary(props) {
    var errors = _convertValidationErrors(props.errors, props.name);
    if (errors) {
        return React.createElement("ul", { className: props.className || "text-danger" }, errors.map((e, idx) => React.createElement("li", { key: idx }, e)));
    }
    return null;
}
//# sourceMappingURL=ValidationErrors.js.map